// import { useState } from 'react';

// /**
//  * Generic form hook
//  * @param {Object} initialValues
//  * @param {Function} validate  — receives values, returns { field: 'error msg' }
//  */
// const useForm = (initialValues, validate) => {
//   const [values, setValues]   = useState(initialValues);
//   const [errors, setErrors]   = useState({});
//   const [touched, setTouched] = useState({});

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setValues(prev => ({ ...prev, [name]: value }));
//     // Clear error on change
//     if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
//   };

//   const handleBlur = (e) => {
//     const { name } = e.target;
//     setTouched(prev => ({ ...prev, [name]: true }));
//     if (validate) {
//       const fieldErrors = validate(values);
//       setErrors(prev => ({ ...prev, [name]: fieldErrors[name] || '' }));
//     }
//   };

//   const validateAll = () => {
//     if (!validate) return true;
//     const fieldErrors = validate(values);
//     setErrors(fieldErrors);
//     setTouched(Object.keys(initialValues).reduce((acc, k) => ({ ...acc, [k]: true }), {}));
//     return Object.keys(fieldErrors).length === 0;
//   };

//   const reset = () => {
//     setValues(initialValues);
//     setErrors({});
//     setTouched({});
//   };

//   return { values, errors, touched, handleChange, handleBlur, validateAll, reset };
// };

// export default useForm;


import { useState } from "react";

const useForm = (initialValues, validate) => {
  const [values,  setValues]  = useState(initialValues);
  const [errors,  setErrors]  = useState({});
  const [touched, setTouched] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prev) => ({ ...prev, [name]: value }));
    // Clear error on change if field was already touched
    if (touched[name]) {
      const newErrors = validate({ ...values, [name]: value });
      setErrors((prev) => ({ ...prev, [name]: newErrors[name] }));
    }
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
    const newErrors = validate(values);
    setErrors((prev) => ({ ...prev, [name]: newErrors[name] }));
  };

  // Run full validation, mark all fields touched, return true if valid
  const validateAll = () => {
    const newErrors = validate(values);
    setErrors(newErrors);
    const allTouched = Object.keys(values).reduce((acc, key) => ({ ...acc, [key]: true }), {});
    setTouched(allTouched);
    return Object.keys(newErrors).length === 0;
  };

  const reset = () => {
    setValues(initialValues);
    setErrors({});
    setTouched({});
  };

  return { values, errors, touched, handleChange, handleBlur, validateAll, reset };
};

export default useForm;